import { Outlet, Link } from 'react-router-dom';
import { brandConfig } from '../config';
import { useTheme } from '../theme/ThemeProvider';
import NetPromoterScore from 'src/components/net-promoter-scale';
import { useAuthContext } from '../auth/useAuthContext';
import { Roles } from '../utils/owner-portal/userConstants';
import { useGetRTKQOwnerProfileQuery } from '../redux/rtkQuery/apiSlice';

export default function CompactLayout() {
  const { resolvedMode } = useTheme();
  const { user } = useAuthContext();
  const isOwner = user?.role === Roles.User;
  const { data: ownerProfile } = useGetRTKQOwnerProfileQuery(undefined, { skip: !isOwner });
  const showNps =
    isOwner &&
    ownerProfile?.npsOptOut === false &&
    ownerProfile.npsLastSendDate != null &&
    (ownerProfile.npsLastSubmitDate == null ||
      ownerProfile.npsLastSubmitDate < ownerProfile.npsLastSendDate);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Header */}
      <header className="flex h-16 items-center justify-center border-b px-2 lg:px-4">
        <Link to="/">
          <img
            src={resolvedMode === 'dark' ? brandConfig.logoUrlDark : brandConfig.logoUrl}
            alt={brandConfig.name}
            className="h-10 w-auto"
          />
        </Link>
      </header>

      {/* Content */}
      <main className="flex flex-1 items-center justify-center p-2 lg:p-4">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>

      {showNps && ownerProfile?.npsLastSendDate != null && (
        <NetPromoterScore showOnLoad npsLastSendDate={ownerProfile.npsLastSendDate} />
      )}

      {/* Footer */}
      <footer className="flex h-16 items-center justify-center border-t px-2 lg:px-4">
        <p className="text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} {brandConfig.name}. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
